/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * DSV Public API
 * DSV Public API
 * OpenAPI spec version: 1.5.2
 */

export type AgeRestrictionType = typeof AgeRestrictionType[keyof typeof AgeRestrictionType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AgeRestrictionType = {
  NO_RESTRICTION: 'NO_RESTRICTION',
  AGE: 'AGE',
  YEAR: 'YEAR',
} as const;
